<template>
  <div class="info" v-bind:style="{ direction }">
    <div
      class="icon icon-info notranslate"
      v-if="hasValidIcon"
      aria-hidden="true"
      data-nosnippet
      translate="no"
    >
      <md-icon>{{ validIcon }}</md-icon>
    </div>
    <h4 class="info-title">{{ contentHtml }}</h4>

    <span v-html="contentHtmlbody"></span>
  </div>
</template>

<script>
import RichTextResolver from "storyblok-js-client/dist/rich-text-resolver.cjs.js";
const resolver = new RichTextResolver();

export default {
  name: "LandingItem",
  props: {
    content: {},
    direction: {
      type: String,
      Defaults: "rtl",
    },
  },
  watch: {
    content(val, oldVal) {
      this.contentHtml = this.getContentHtml();
      this.contentHtmlbody = this.getContentHtmlbody();
      this.contentIcon = this.getContentIcon();
    },
  },
  data() {
    return {
      contentHtml: this.getContentHtml(),
      contentHtmlbody: this.getContentHtmlbody(),
      contentIcon: this.getContentIcon(),

      defaultIcon: "info",
    };
  },
  computed: {
    validIcon() {
      const icon = this.contentIcon;
      if (!icon) return this.defaultIcon;

      // Convert to lowercase and replace spaces/special chars with underscores
      return icon
        .toString()
        .toLowerCase()
        .trim()
        .replace(/[\s-]+/g, "_");
    },
    hasValidIcon() {
      return this.contentIcon && this.contentIcon.toString().trim() !== "";
    },
  },
  methods: {
    getContentHtml() {
      return this.content.title;
    },
    getContentHtmlbody() {
      return this.content.description
        ? resolver.render(this.content.description)
        : "";
    },
    getContentIcon() {
      return this.content.Icon;
    },
  },
};
</script>
